import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { CITIES } from "../mock/mockData";

const TR = { ğ: "g", Ğ: "g", ü: "u", Ü: "u", ş: "s", Ş: "s", ı: "i", İ: "i", ö: "o", Ö: "o", ç: "c", Ç: "c" };
export const trSlug = (s) =>
  (s || "")
    .split("").map((c) => TR[c] || c).join("")
    .toLowerCase().trim()
    .replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// city name <-> slug maps
export const CITY_SLUGS = CITIES.map((c) => ({ name: c, slug: trSlug(c) }));
export const citySlug = (name) => trSlug(name);
export const cityFromSlug = (slug) => {
  const f = CITY_SLUGS.find((c) => c.slug === slug);
  return f ? f.name : null;
};

export const SITE = "DüğünSenin";
export const ORIGIN = (typeof window !== "undefined" && window.location.origin) || "https://dugunsenin.com";

export const Seo = ({ title, description, canonical, ogImage, noindex, jsonLd }) => {
  useEffect(() => {
    if (title) document.getElementById("static-title")?.remove();
    if (description) document.getElementById("static-desc")?.remove();
  }, [title, description]);
  const url = canonical ? (canonical.startsWith("http") ? canonical : `${ORIGIN}${canonical}`) : undefined;
  const blocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {url && <link rel="canonical" href={url} />}
      {noindex && <meta name="robots" content="noindex,follow" />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};

export const orgJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE,
  url: ORIGIN,
  logo: `${ORIGIN}/favicon-heart.png`,
});

export const websiteJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE,
  url: ORIGIN,
});

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.url.startsWith("http") ? it.url : `${ORIGIN}${it.url}`,
  })),
});

// LocalBusiness — only real data; AggregateRating only if real reviews exist
export const venueJsonLd = (v, canonical) => {
  const ld = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: v.name,
    url: canonical.startsWith("http") ? canonical : `${ORIGIN}${canonical}`,
  };
  if (v.description) ld.description = v.description;
  if (v.image) ld.image = v.image.startsWith("http") ? v.image : `${ORIGIN}${v.image}`;
  const addr = {};
  if (v.city) addr.addressRegion = v.city;
  if (v.district) addr.addressLocality = v.district;
  if (Object.keys(addr).length) ld.address = { "@type": "PostalAddress", addressCountry: "TR", ...addr };
  if (v.priceFrom && Number(v.priceFrom) > 0) ld.priceRange = `₺${v.priceFrom}+`;
  if (Number(v.reviews) > 0 && Number(v.rating) > 0) {
    ld.aggregateRating = { "@type": "AggregateRating", ratingValue: Number(v.rating), reviewCount: Number(v.reviews) };
  }
  return ld;
};
